import {Status} from 'platform/components';
import {Show, Text, VStack} from 'platform/foundation';

import {isNilOrEmpty, isNotNilOrEmpty} from 'ramda-adjunct';

import {BusinessCaseActivityResponseBody} from '@dms/api/sales';
import {ServiceCaseActivityResponseBody} from '@dms/api/workshop';
import i18n from '@dms/i18n';

import {ServiceCaseActivityItem} from './ServiceCaseActivityItem';

interface ServiceCaseActivityListProps {
  label: string;
  items: (ServiceCaseActivityResponseBody | BusinessCaseActivityResponseBody)[];
  contactName?: string | null;
  serviceCaseNumber?: string | null;
  serviceOrders: {serviceOrderId: string; number: string}[];
  showEmpty?: boolean;
}

export function ServiceCaseActivityList(props: ServiceCaseActivityListProps) {
  return (
    <VStack spacing={4} height="auto">
      <Text size="xSmall" color="secondary">
        {props.label}
      </Text>

      <Show when={props.showEmpty && isNilOrEmpty(props.items)}>
        <Status headline={i18n.t('entity.activityPanel.activity.noNextSteps')} />
      </Show>

      <VStack spacing={0}>
        <Show when={isNotNilOrEmpty(props.items)}>
          {props.items.map((item, index) => (
            <ServiceCaseActivityItem
              key={item.id}
              item={item}
              contactName={props.contactName}
              serviceCaseNumber={props.serviceCaseNumber}
              serviceOrders={props.serviceOrders}
              isLastItem={index === props.items.length - 1}
            />
          ))}
        </Show>
      </VStack>
    </VStack>
  );
}
